import { boolOrIntCodec } from '../../validation/codecs';
import {enumCodec, mixed, optional, required, t} from '../../validation/validator';
import { CallResponseSchema } from '../common/callResponseSchema';

/****************************************************
 * Kit Schemas START
 ****************************************************/

// io-ts string with string length greater than 0
const filledStringCodec = t.refinement(t.string, (s) => s.length > 0);

enum MapType {
    MASK = "MASK",
    ALBEDO = "ALBEDO",
}

// Kit Schema
export const KitSchema = required({
    name: filledStringCodec,
    primary: t.string,
    secondary: t.string,
    tertiary: t.string,
    goalkeeper_primary: t.string,
    goalkeeper_secondary: t.string,
    goalkeeper_tertiary: t.string
});

// Kit Record Schema
export const KitRecordSchema = mixed([
    KitSchema,
    required({
        // Required fields
        id: t.number,
        created_at: t.string,
        updated_at: t.union([t.string, t.undefined, t.null])
    }),
    optional({
        map_type: t.union([enumCodec(MapType), t.null]),
        color_map: t.union([t.string, t.null]),
        goalkeeper_color_map: t.union([t.string, t.null]),
        is_global: boolOrIntCodec,
    })
]);

export type Kit = t.TypeOf<typeof KitSchema>;

export type KitRecord = t.TypeOf<typeof KitRecordSchema>;

// Kit Insert Schemaa
const KitInsertSchema = KitSchema;
export type KitInsert = t.TypeOf<typeof KitInsertSchema>;

// Kit Update Schema
export const UpdateKitRequestSchema = mixed([
    KitSchema,
    required({
        create: t.boolean
    }),
    optional({
        is_global: boolOrIntCodec,
        kit_id: t.number
    })
]);

export type UpdateKitRequest = t.TypeOf<typeof UpdateKitRequestSchema>;
export const UpdateKitResponseSchema = mixed([
    required({
        data: KitRecordSchema
    }),
    CallResponseSchema
])
export type UpdateKitResponse = t.TypeOf<typeof UpdateKitResponseSchema>;

/****************************************************
 * Kit Schemas END
 ****************************************************/
export const AvatarApis = {
    Avatars: {
        UpdateKit: {
            Name: "avatars-updateKit",
            Request: UpdateKitRequestSchema,
            Response: mixed([
                required({
                    data: KitRecordSchema
                }),
                CallResponseSchema
            ])
        },
        GetKits: {
            Name: "avatars-getKits",
            Request: optional({
                kit_ids: t.array(t.number),
                search_query: t.string,
                limit: t.number,
                offset: t.number,
                global_only: boolOrIntCodec
            }),
            Response: mixed([
                required({
                    data: t.array(KitRecordSchema),
                    total_count: t.number
                }),
                CallResponseSchema
            ])
        },
        UpdateSourceImage: {
            Name: "avatars-updateSourceImage",
            Request: required({
                user_id: t.number,
                avatar_id: t.number,
                sourceImage: t.string,
                rpm_id: t.string,
                rpm_auth_token: t.string
            }),
            Response: CallResponseSchema
        }
    }
};

